/**
 * The fields a list row selects. Shared so the workspace copy downloads exactly
 * what the list renders.
 */
export const LIST_ASSET_ITEM_FRAGMENT = `
          id
          name
          description
          details
          serialNumber
          productName
          lastAddress
          lastScannedAt
          lastUpdated
          createdAt
          createdBy
          numNotes
          numAlerts
          numReportsRed
          numReportsYellow
          numReports
          numRoutines
          addonsCount
          groups {
            id
            name
          }
          tagCode
          routineState {
            state
            workspaceRoutineId
            workspaceRoutineVersionId
          }
          workspaces {
            id
            name
            type
          }
`;

export const LIST_ASSETS = `
  query FindAssets($filter: ListAssetsFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    asset {
      listAssets(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        limit
        offset
        items {${LIST_ASSET_ITEM_FRAGMENT}        }
      }
    }
  }
`;
